import styled from 'styled-components';
import { Typ30 } from '../Typ';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 14px 0;
  width: 100%;
`;

export const TextWrapper = styled(Typ30)`
  margin: 0 24px;
  flex-shrink: 0;
`;

export const Line = styled.div`
  height: 1px;
  flex-grow: 1;
  background-color: #cfd8dc;
`;
